<markant-platform-booking-form-content
  [bookingDataForm]="additionalBookingDataForm"
  [bookingData]="bookingData"
  [submitted]="submitted"
></markant-platform-booking-form-content>
<div class="button-container flex-row-centered">
  <markant-button
    data-cy="order-request-back-button"
    colorScheme="primary"
    variant="clear"
    (click)="goBack()"
  >
    <markant-icon
      class="button-icon"
      icon="m_arrow-left"
      slot="icon-leading"
    ></markant-icon>
    <span>{{ 'general.back' | transloco }}</span>
  </markant-button>
  <div class="next-text flex-row-centered">
    {{ 'booking.form.nextText' | transloco }}
  </div>
  <markant-button
    data-cy="order-request-continue-button"
    class="next-button"
    colorScheme="primary"
    (click)="submit()"
  >
    <span>{{ 'general.next' | transloco }}</span>
  </markant-button>
</div>
